/*=========================================================================================
  File Name: state.js
  Namespace: exercises
  Description: Vuex Store - Exercise state
==========================================================================================*/

export const buildExerciseState = () => {
  return {
    id: null,
    name: '',
    slug: '',
    description: '',
    description_html: '',
    starter_code: '',
    language: '',
    instructor_id: null,
    created: null,
    modified: null,
    files: [],
    duration_in_seconds: 0,
  }
}

// /////////////////////////////////////////////
// State
// /////////////////////////////////////////////

const state = {
  currentExercise: buildExerciseState(),
  exerciseList: null,
  count: 0,
  next: null,
  previous: null,
  results: [],
  currentTests: {},
  currentSolutions: {},
  currentExerciseFiles: []
}

export default state